module.exports = __webpack_public_path__ + "static/year_landscape_with_list-f5735b6776c9c41d18791fa5cbd68dfc.png";